/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class WebhookDomarRequest {
    'competitionId': string;
    'classId': string;
    'eventId': string;
    'keppnisgrtegNafn': string;
    'flokkstegNafn': string;
    'keppniNafn': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "competitionId",
            "baseName": "competitionId",
            "type": "string",
            "format": ""
        },
        {
            "name": "classId",
            "baseName": "classId",
            "type": "string",
            "format": ""
        },
        {
            "name": "eventId",
            "baseName": "eventId",
            "type": "string",
            "format": ""
        },
        {
            "name": "keppnisgrtegNafn",
            "baseName": "keppnisgrtegNafn",
            "type": "string",
            "format": ""
        },
        {
            "name": "flokkstegNafn",
            "baseName": "flokkstegNafn",
            "type": "string",
            "format": ""
        },
        {
            "name": "keppniNafn",
            "baseName": "keppniNafn",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return WebhookDomarRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

